import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enVault from './locales/en/vault.json';
import enTransactions from './locales/en/transactions.json';
import enSettings from './locales/en/settings.json';

import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frVault from './locales/fr/vault.json';
import frTransactions from './locales/fr/transactions.json';
import frSettings from './locales/fr/settings.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        dashboard: enDashboard,
        vault: enVault,
        transactions: enTransactions,
        settings: enSettings,
      },
      fr: {
        common: frCommon,
        dashboard: frDashboard,
        vault: frVault,
        transactions: frTransactions,
        settings: frSettings,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'g12_lang',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
